import { DropDownItem } from '../../../../../base/shared/drop-down-item.model';
import { DropDownConstantsFactory } from '../../../../../base/shared/syncfusion/dropdown-constants-factory';
import { EnumTranslationService } from '../../../../../base/services/enum-translation.service';
import { AbstractControl, AsyncValidatorFn, Validators, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CountryISO2 } from 'src/app/base/shared/countryISO2-enum';
import { ControlPlateType, ParkerTagClient, ParkerTagDTO } from '../../../../../base/models/models.swagger.generated';
import { DialogComponent as SyncfusionDialogComponent } from '@syncfusion/ej2-angular-popups/src/dialog/dialog.component';
import { timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ClientService } from '../../../../../base/services/client/client.service';
import { TagType } from './tag-type.enum';
import { TranslateModule } from '@ngx-translate/core';
import { QrScannerComponent } from '../../../../../base/shared/qr-scanner/qr-scanner.component';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { NgIf } from '@angular/common';
import { EnumDropDownListComponent } from '../../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { EditParkerEditTagListFormGroup } from './edit-parker-edit-tag-list-form.type';
import { MessageModule } from '@syncfusion/ej2-angular-notifications';

@Component({
    selector: 'app-edit-parker-edit-tag-list-form',
    templateUrl: './edit-parker-edit-tag-list-form.component.html',
    styleUrls: ['./edit-parker-edit-tag-list-form.component.scss'],
    standalone: true,
    imports: [
        ReactiveFormsModule,
        AppErrorMessagesComponent,
        DropDownListModule,
        EnumDropDownListComponent,
        NgIf,
        YesNoGroupButtonComponent,
        DialogModule,
        QrScannerComponent,
        TranslateModule,
        MessageModule
    ],
})
export class EditParkerEditTagListFormComponent implements OnInit {

  @Input() public parkerTagForm: EditParkerEditTagListFormGroup;
  @Input() public allTags: ParkerTagDTO[];

  @ViewChild('cardReaderDialog') public cardReaderDialog: SyncfusionDialogComponent;
  @ViewChild('qrReaderDialog') public qrReaderDialog: SyncfusionDialogComponent;

  public enumDropdownSettings = DropDownConstantsFactory.createEnumDropdownSettings();
  public countryList: DropDownItem[];
  public ControlPlateType = ControlPlateType;
  public TagType = TagType;

  public showQrText = false;

  public cardReaderForm = this.fb.group({
    identificationCode: [null, {validators: [Validators.required], asyncValidators: [this.idValidator()]}],
  });

  public get isAdd(): boolean {
    return !this.parkerTagForm.value.id;
  }

  public get clientIdent(): string {
    return this.clientService.selectedClient.clientIdent;
  }

  constructor(private enumTranslationService: EnumTranslationService,
              private parkerTagClient: ParkerTagClient,
              private clientService: ClientService,
              private fb: FormBuilder) {
  }

  public ngOnInit(): void {
    this.countryList = this.enumTranslationService.translateEnum(CountryISO2, 'i18n.shared.CountryISO2.');
    // this.countryList = [{key: 'CH', value: 'Switzerland'}, {key: 'DE', value: 'asdf'}];
  }

  public openCardReaderDialog(): void {
    this.cardReaderDialog.show();
  }

  public openQrReaderDialog(): void {
    this.qrReaderDialog.show();
  }

  public saveIdCode(): void {
    this.parkerTagForm.controls.identificationCode.setValue(this.cardReaderForm.controls.identificationCode.value);
    this.closeCardDialog();
  }

  public onQrScanned(qrData: string): void {
    this.parkerTagForm.controls.barcode.setValue(qrData.split('.')[2]);
    this.closeQrDialog();
  }

  public closeCardDialog(): void {
    this.cardReaderForm.controls.identificationCode.reset();
    this.cardReaderDialog.hide();
  }

  public closeQrDialog(): void {
    this.qrReaderDialog.hide();
    this.showQrText = false;
  }

  private idValidator(): AsyncValidatorFn {
    return (control: AbstractControl) => timer(500)
      .pipe(
        switchMap(() => this.parkerTagClient.isIdentificationCodeAlreadyInUse(this.clientService.selectedClient.id, control.value)),
        map(result => {
          const sameAsOriginal = this.allTags
            .find(t => t.id === this.parkerTagForm.controls.id.value)?.identificationCode === control.value;
          const isAlreadyInUse = this.allTags.some(t => t.identificationCode === control.value);
          return sameAsOriginal || (!isAlreadyInUse && !result) ? null : {identAlreadyInUse: true};
        }),
      );
  }
}
